export const achievements = [
  {
    img: "https://media.licdn.com/dms/image/v2/C4D03AQF9oHQJX8mKGA/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1655186366242?e=1730332800&v=beta&t=2u6wE6pX6Oc4Roy2aLATJzbVjInEa0zvaS3XrjK5Yqs",
    name: "Shekhar Mishra",
    batch: "2020-24",
    achievements: "SWE at Microsoft",
  },
  {
    img: "https://media.licdn.com/dms/image/v2/C4D03AQEatv7P9Aso-w/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1651746196592?e=1730332800&v=beta&t=_WKkn9_qse81Uauxp3pOBvWAxKF0rfVO-ZWGSaEFHXA",
    name: "Deepti Mittal",
    batch: "2020-24",
    achievements: "SDE @Xeno | Offered Juspay, Josh Technologies",
  },
  {
    img: "https://media.licdn.com/dms/image/v2/D5635AQGjh-QoZIKR5w/profile-framedphoto-shrink_400_400/profile-framedphoto-shrink_400_400/0/1703348681758?e=1725631200&v=beta&t=HK7AQEFGQboS-uldiGiWWlpYRevHr8lM4REJ53jUm3s",
    name: "Vishakha Aggarwal",
    batch: "2020-24",
    achievements: "Ex-SDE Intern @Amazon",
  },
  {
    img: "https://res.cloudinary.com/df5hitkbj/image/upload/v1693141355/WhatsApp_Image_2023-08-27_at_18.31.44_bcdpq4.jpg",
    name: "Pradeepto Sarkar",
    batch: "2020-24",
    achievements: `
        Technical Program Associate @ Major League Hacking | MLH SWE Fellow Fall ‘23 | 2x GSoC Accepted | Harvard Aspire Global Semis | 4* Codechef | Specialist CodeForces
      `,
  },
  {
    img: "https://media.licdn.com/dms/image/v2/D5603AQEnTWdKmzz8Rg/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1687343948331?e=1730332800&v=beta&t=TIKThKJsKH7dPjUgKNfKLU-YmbUgCML9FbyLxyydv7o",
    name: "Surbhi Sinha",
    batch: "2020-24",
    achievements: "EX-SWE Intern @ MICROSOFT | Microsoft engage mentee 22 | Smart India Hackathon pre finalist",
  },
  {
    img: "https://media.licdn.com/dms/image/v2/D5603AQGJAOML1QLE6A/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1720817109082?e=1730332800&v=beta&t=8fCB9fOXhfSMMTfY7kbKMpLVkR9OBoty-HoohvPEUew",
    name: "Tushar Rai",
    batch: "2020-24",
    achievements: "SDE @RecruitCRM | 4🌟Codechef",
  },
  {
    img: "https://media.licdn.com/dms/image/v2/D5603AQEug3DhKMILkw/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1703964505583?e=1730332800&v=beta&t=JgidDe2lmeraffdx99IxqlKd6EOolApi08kzFAR6vZs",
    name: "Himank Jain",
    batch: "2020-24",
    achievements: "Security Engineer @ Finesse | Ex-Deloitte | LPT(Master) | CPENT | CEH(Master)",
  },
  {
    img: "https://user-images.githubusercontent.com/75252077/236657010-53641de3-591f-4a61-87c6-c94d2209d52f.jpg",
    name: "Kartik Sharma",
    batch: "2020-24",
    achievements: `
        SDE @ Physics Wallah | 5* Codechef | Expert CodeForces
      `,
  },
  {
    img: "https://media.licdn.com/dms/image/v2/C4D03AQH9HcLkhNXhXg/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1649775467634?e=1730332800&v=beta&t=93sL960LVcPBZE5dMvsD4JgmvBRMmgcPj3zdZhfSbDQ",
    name: "Prasuk Jain",
    batch: "2020-24",
    achievements: "AI Developer at DIRO",
  },
  {
    img: "https://media.licdn.com/dms/image/v2/D4D03AQGolrfCL91E_g/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1665224901957?e=1730332800&v=beta&t=2LPXUutZ2up6yVD4g-EDWnrL1IMf0MrYRRUNZDORXxo",
    name: "Harsh Kumar",
    batch: "2020-24",
    achievements: "SDE 2 @Newgen Software",
  },
  {
    img: "https://media.licdn.com/dms/image/v2/D5603AQEuB-L9DIvzGg/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1724802336276?e=1730332800&v=beta&t=NGD074f-tfVTJ20mNtAIls_Ke_vFypSyU0gSDUQ_r_I",
    name: "Manan Khandelwal",
    batch: "2020-24",
    achievements: "SDE @Badho",
  },
  {
    img: "https://media.licdn.com/dms/image/v2/C4D03AQG6MLb0EvjKBw/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1646925058669?e=1730332800&v=beta&t=eWRgm5DtrCvP9tf2SKf01aJquGuy0exinQ-zJuCqLfw",
    name: "Nishant Mittal",
    batch: "2020-24",
    achievements: "Android Developer @SBNRI",
  },
  {
    img: "https://media.licdn.com/dms/image/v2/D4E03AQEz9A4EIi60JQ/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1718319641954?e=1730332800&v=beta&t=yapnVIJQD8fJrZR7W2rlea38pv2cxf130l_COKafzpE",
    name: "Shivang Gautam",
    batch: "2020-24",
    achievements: "Android Intern @Jar | Ex- Android Intern [@Lifease Solutions LLP, @Henix Rehab]",
  },
  {
    img: "https://media.licdn.com/dms/image/v2/D5603AQFy4MAFW3nvOg/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1704521613795?e=1730332800&v=beta&t=XqPPsbW2SD99qgerweI3dKyWIqTsCYVEjPnKEAupFAk",
    name: "Siddhant Singh",
    batch: "2020-24",
    achievements: "IT Analyst Intern @NCR Atleos | ex Python Intern@AIE, DevOps@Infrasity, SWE@HyperSpace",
  },
  {
    img: "",
    name: "Simran Panjwani",
    batch: "2020-24",
    achievements: "SDE Intern @NCR Atleos | ex @TexlaCulture @Pycray",
  },
  {
    img: "",
    name: "Ankur Sharma",
    batch: "2020-24",
    achievements: "SME @Newton School of Technology | Specialist @CodeForces | 4⭐@CodeChef | Knight at Leetcode | Web Developer",
  },
  {
    img: "",
    name: "Ashutosh Kumar",
    batch: "2020-24",
    achievements: "Finalist code gladiator22 ||4* CodeChef|| Specialist @CodeForces",
  },
  {
    img: "",
    name: "Deepanshu Dua",
    batch: "2020-24",
    achievements: "Software Engineer @NCR Atleos || 3🌟 at CodeChef",
  },
  {
    img: "https://media.licdn.com/dms/image/v2/D4D35AQG9YHcjOA2yGw/profile-framedphoto-shrink_400_400/profile-framedphoto-shrink_400_400/0/1691570849477?e=1725631200&v=beta&t=4ba9-Td9C_evblDIhlSJi6RgSh65JhxUWEXCOMt_whc",
    name: "Udit Soni",
    batch: "2020-24",
    achievements: "Flutter Developer @IWayPlus",
  },
  {
    img: "https://media.licdn.com/dms/image/v2/D5603AQHNrhvuspyMvw/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1719757002703?e=1730332800&v=beta&t=YzmcJ4sZqM02LYj4m0MpViZhPQP5hOSjZ8H2cZHJKoY",
    name: "Vaibhav Soni",
    batch: "2020-24",
    achievements: "IIM Ranchi MBA-BA’26",
  },
  {
    img: "https://media.licdn.com/dms/image/v2/C5603AQHIRis1VPpoxA/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1618693554447?e=1730332800&v=beta&t=FQ3z_zca1iS11RWZ_BbjRSALGxpjw4vK_u2M_HTNyik",
    name: "Yuvah L Kumar",
    batch: "2020-24",
    achievements: "CEO & Founder at YCL NET SURAKSHA | Community Leader At CyberWorldOrg | Chief Project Manager at CFB | Head Coordinator at CodersFlowAI",
  },
  {
    img: "https://media.licdn.com/dms/image/v2/D5603AQE0h904PKTh9g/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1725097233486?e=1730937600&v=beta&t=ZX2meGHEPZx5jJKoqcSWI458Xsph8smut15FJzvzaQo",
    name: "Zardam Hussain",
    batch: "2020-24",
    achievements: "SDE @ Linkiss | Knight @ LeetCode",
  },
  {
    img: "",
    name: "Deepika",
    batch: "2020-24",
    achievements: "Software Engineer @Persistent Systems",
  },
  {
    img: "https://media.licdn.com/dms/image/v2/D4D35AQHm9oXF46HkQA/profile-framedphoto-shrink_400_400/profile-framedphoto-shrink_400_400/0/1682093583031?e=1725631200&v=beta&t=dxy-naHrbb2LU_wwy_xSsa4cyXqI7Onmt8DjOuB7a4w",
    name: "Prishita Aggarwal",
    batch: "2020-24",
    achievements: "Trainee Engineer @BluePi",
  },
  {
    img: "https://media.licdn.com/dms/image/v2/D5603AQHJ4n1fIeLg1A/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1721498305119?e=1730332800&v=beta&t=fCLKzuCoNdXXd-oquqYPjpSAp6Czeoft_4pQMkIGPww",
    name: "Vishesh Khare",
    batch: "2020-24",
    achievements: "Salesforce Developer @Makedian",
  },
  {
    img: "https://user-images.githubusercontent.com/75252077/236658748-0dd5a22a-52eb-471c-8662-36efa310a38e.jpg",
    name: "Vaibhav Goyal",
    batch: "2021-25",
    achievements: `
        ICPC Regionalist 2023-24 | Expert @ Codeforces | 5* Codechef | Ex- VP @ The nameSpace Community
      `,
  },
  {
    img: "https://media.licdn.com/dms/image/v2/D5635AQGYqjw5b0mvOA/profile-framedphoto-shrink_400_400/profile-framedphoto-shrink_400_400/0/1698242386084?e=1725793200&v=beta&t=UvYfXdcGxSGSFSMQJVesGnaA_iBwfabGyja_x2_JyzA",
    name: "Rishi Jha",
    batch: "2021-25",
    achievements: `
        ICPC Regionalist 2023-24 | Expert @Codeforces (1642 max) | 4 ⭐ @Codechef (1963 max) | KNIGHT @Leetcode (2102 max)`,
  },
  {
    img: "https://media.licdn.com/dms/image/v2/C5603AQFWxylDBpKgIQ/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1639306814631?e=1730937600&v=beta&t=7HAYLwwAnakq89gJaGRdsFQEG9jBe1KLXT3gno80L1I",
    name: "Jaskirat Singh",
    batch: "2021-25",
    achievements: `
        MITACS GRI’24 | Blockchain Educator @ Decentraclasses | Building OpinioNect | Hackathon Aficionado
      `,
  },

  {
    img: "https://media.licdn.com/dms/image/v2/D5603AQGiAdAyhvHTrQ/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1715278957439?e=1730332800&v=beta&t=sFUzbspHzWHJQR2xmFIaArW4rTX8IVQYS8WVutZiwgk",
    name: "Akkul Gautam",
    batch: "2021-25",
    achievements: "SDE Intern @Juspay || Specialist @codeforces || Knight @Leetcode(1923 rated) || 3⭐ Codechef",
  },
  {
    img: "https://res.cloudinary.com/df5hitkbj/image/upload/v1693144357/WhatsApp_Image_2023-08-27_at_19.22.07_aar0ka.jpg",
    name: "Anushka Singh",
    batch: "2021-25",
    achievements: "Ex- Design Intern @VMC",
  },
  {
    img: "https://media.licdn.com/dms/image/v2/D4D03AQFTGDdbnsEC3w/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1687888933399?e=1730332800&v=beta&t=GRRxLGtfZq_zxMAVq4fniS8dAY3gaC5nDxWuCZGS2w4",
    name: "Arjun Bhardwaj",
    batch: "2021-25",
    achievements: "3 ⭐ @Codechef (Max.1618) | Pupil @Codeforces (Max.1290)",
  },
  {
    img: "https://media.licdn.com/dms/image/v2/D5635AQH3Hu47uX2SqQ/profile-framedphoto-shrink_400_400/profile-framedphoto-shrink_400_400/0/1712087647688?e=1725631200&v=beta&t=7LaxGMXNrcnZOFE7QF-aYz1Dz-efERoHbDIUPtKwPxQ",
    name: "Ataf Ali",
    batch: "2021-25",
    achievements: "Intern @SixSense Mobility",
  },
  {
    img: "https://media.licdn.com/dms/image/v2/D4D03AQFfzqLghamIsA/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1698400339524?e=1730332800&v=beta&t=tmSFLvA_3MaFE812orSbhz_CWMRVUa5z_ccX9DPiEiI",
    name: "Himanshu Rawat",
    batch: "2021-25",
    achievements: "SDE Intern @ Xeno",
  },
  {
    img: "https://media.licdn.com/dms/image/v2/D4D35AQFKaYDRyzYdfw/profile-framedphoto-shrink_400_400/profile-framedphoto-shrink_400_400/0/1694512922323?e=1725631200&v=beta&t=CfGl7s4l10Lcf8jb369qqp3Wy6Xtq_aKQN326fC6Q2Y",
    name: "Jyoti Saha",
    batch: "2021-25",
    achievements: "Ex-Intern @DRDO | Ex-Intern @Central Electronics Limited",
  },
  {
    img: "https://media.licdn.com/dms/image/v2/D4D35AQHx0m50TVLUmQ/profile-framedphoto-shrink_400_400/profile-framedphoto-shrink_400_400/0/1702364339463?e=1725631200&v=beta&t=j7IYYVSCsJ509T9vxzrY--cP31R8Ufgat4WclgZEn3A",
    name: "Pawas Goyal",
    batch: "2021-25",
    achievements: "SDE Intern @Unthinkable Solutions",
  },
  {
    img: "https://media.licdn.com/dms/image/v2/D4D03AQEtz26EJhAkBw/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1677238142190?e=1730332800&v=beta&t=_chDGT76UIkgv8wxuGHG5QDB2TAyNvjBo9ZDR58JeQk",
    name: "Saransh Khandelwal",
    batch: "2021-25",
    achievements: "Dynamics 365 intern @Alletec",
  },
  {
    img: "",
    name: "V V Anup Sreeram",
    batch: "2021-25",
    achievements: "SDE Intern @WUE",
  },
  {
    img: "https://media.licdn.com/dms/image/v2/D5635AQGKrYmz8SNe6A/profile-framedphoto-shrink_400_400/profile-framedphoto-shrink_400_400/0/1719472686696?e=1725631200&v=beta&t=jIYV48-NWX_GNqrh7wlXsYcJstLBGNY3U4X0HMd8JpE",
    name: "Vibhuti Gupta",
    batch: "2021-25",
    achievements: "Web Dev Intern @ark Infosolutions",
  },
  {
    img: "https://res.cloudinary.com/df5hitkbj/image/upload/v1701314230/Akshit_Shroff_mgbxhf.jpg",
    name: "Akshit Shroff",
    batch: "2021-25",
    achievements: "",
  },
  {
    img: "https://res.cloudinary.com/df5hitkbj/image/upload/v1696347467/WhatsApp_Image_2023-10-03_at_19.48.38_9b68ab3a_pdkmkv.jpg",
    name: "Gautam Gupta",
    batch: "2021-25",
    achievements: "SDE Intern @Juspay",
  },
  {
    img: "https://media.licdn.com/dms/image/v2/D4E03AQG9Y7N6DK36Hw/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1702396261744?e=1730332800&v=beta&t=hHEEQbrNZintR0rgKNqGIYN0d5XDxElqM0s566TO4hk",
    name: "Lavanshi Bansal",
    batch: "2021-25",
    achievements: "Web Developer intern @Mitrakriti Pvt. Ltd.",
  },
  {
    img: "https://user-images.githubusercontent.com/75252077/236658902-912d6d6c-6790-41ee-b65b-5ccd4e2eea40.jpeg",
    name: "Raj Verma",
    batch: "2021-25",
    achievements: "",
  },
  {
    img: "https://user-images.githubusercontent.com/75252077/236658653-d05fa062-283e-4520-9a71-4d01d7f2b4f4.jpg",
    name: "Rishav Raj",
    batch: "2021-25",
    achievements: "",
  },
  {
    img: "https://res.cloudinary.com/df5hitkbj/image/upload/v1693238094/shivank_hglloc.jpg",
    name: "Shivank Kapur",
    batch: "2022-26",
    achievements: `
        Developer Relations Intern @ Router Protocol | Web3 & Blockchain Head @ The nameSpace Community | Ex- DogeCapital, Ex-PushProtocol
      `,
  },
  {
    img: "https://media.licdn.com/dms/image/v2/D5603AQGJ-U_IyIeYzA/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1706438258674?e=1730937600&v=beta&t=OSUTnGnun9krxre2tSXDLHZTwmk8NYqByz2e7MpA-k8",
    name: "Ankur Sharma",
    batch: "2022-26",
    achievements: `
        Security intern @ Delhi Police | Security intern @ Gurugram Police | 2nd @ Hackathon Reckon 5.0 | 3rd @ Hackathon HackHazards
      `,
  },
  {
    img: "https://media.licdn.com/dms/image/v2/D5603AQGgAoSRs-iK5w/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1720622397953?e=1730937600&v=beta&t=BGbLdYEvHBQE9eb6zspXrc1wKgKU-Q9k8CaAb0E-Fr0",
    name: "Diksha Sharma",
    batch: "2022-26",
    achievements: "Intern @zbyte | Technical Operations Head @Shiksha Se Shikhar Tak NGO",
  },
  {
    img: "https://res.cloudinary.com/df5hitkbj/image/upload/v1699865734/PranavBarthwal_1_ycli1h.jpg",
    name: "Pranav Barthwal",
    batch: "2022-26",
    achievements: "Developer Advocate @Quira.sh | DevRel @Decentraclasses | ex-Intern @C-DOT",
  },
  {
    img: "https://media.licdn.com/dms/image/v2/D4D03AQHg8RUReWY8Sg/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1690084304947?e=1730937600&v=beta&t=buRQzNINEFH0jT2iWd0gHej3dupXUGYgUg2rRkyXo5E",
    name: "Sahil Tyagi",
    batch: "2022-26",
    achievements: "Intern @Stock Register",
  },
  {
    img: "https://media.licdn.com/dms/image/v2/D5603AQHneLdhpuKweQ/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1721294743442?e=1730937600&v=beta&t=bndWH7eooY1kwhh6awIgooFicMamEUGLFDDbbLHazFI",
    name: "Garv Khurana",
    batch: "2022-26",
    achievements: "ML Intern @Study Buddy",
  },
];
